<template>
    <div class="question_wrapper">
        <template v-if="question_list.length">
            <div class="question_list">
                <div class="question_item"
                     v-for="(ques,q_index) in question_list"
                     :key="ques.id"
                     @click="to(ques,q_index)">
                    <div class="question_content">
                        <div class="question_number"
                             v-if="status=='task'">第{{q_index+1}}题</div>
                        <template v-if="sid==21">
                            <div class="ques_title"
                                 v-html="ques.subject.content"
                                 v-if="ques.subject.content"></div>
                            <img class="title_img"
                                 :src="ques.subject.image"
                                 alt=""
                                 v-if="ques.subject.image">
                            <template v-for="(a,i) in ques.asks">
                                <div class="question_type">【{{ getType(a.display_type) }}】</div>
                                <div class="sub_title">
                                    <span v-if="ques.asks.length>1">({{i+1}})</span>
                                    <span v-html="a.subject.content"
                                          v-if="a.subject.content"></span>
                                    <img class="title_img"
                                         :src="a.subject.image"
                                         alt=""
                                         v-if="a.subject.image">
                                </div>
                            </template>
                        </template>
                        <template v-else-if="sid==22">
                            <div class="ques_title"
                                 v-html="ques.content.content"
                                 v-if="ques.content.content"></div>
                            <img class="title_img"
                                 :src="ques.content.image_url"
                                 alt=""
                                 v-if="ques.content.image_url">
                            <template v-for="(a,i) in ques.asks">
                                <div class="question_type">【{{ getType(ques.display) }}】</div>
                                <div class="sub_title">
                                    <span v-if="ques.asks.length>1">({{i+1}})</span>
                                    <span v-html="a.content.content"
                                          v-if="a.content.content"></span>
                                    <img class="title_img"
                                         :src="a.content.image_url"
                                         alt=""
                                         v-if="a.content.image_url">
                                </div>
                            </template>
                        </template>
                        <template v-else-if="sid==51">
                            <div class="ques_title"
                                 v-html="ques.content"
                                 v-if="ques.content"></div>
                            <img class="title_img"
                                 :src="ques.image"
                                 alt=""
                                 v-if="ques.image">
                            <template v-for="(a,i) in ques.asks">
                                <div class="question_type">【{{getType(a.type)}}】</div>
                                <div class="sub_title">
                                    <span v-if="ques.asks.length>1">({{i+1}})</span>
                                    <span v-html="a.content"
                                          v-if="a.content"></span>
                                    <img class="title_img"
                                         :src="a.image"
                                         alt=""
                                         v-if="a.image">
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <div class="ques_title"
                                 v-html="ques.subject.content"
                                 v-if="ques.subject.content"></div>
                            <img class="title_img"
                                 :src="ques.subject.images"
                                 alt=""
                                 v-if="ques.subject.images">
                            <template v-for="(a,i) in ques.asks">
                                <div class="question_type">【{{getType(ques.type)}}】</div>
                                <div class="sub_title">
                                    <span v-if="ques.asks.length>1">({{i+1}})</span>
                                    <span v-html="a.subject.content"
                                          v-if="a.subject.content"></span>
                                    <img class="title_img"
                                         :src="a.subject.images"
                                         alt=""
                                         v-if="a.subject.images">
                                </div>
                            </template>
                        </template>
                    </div>
                    <div class="item_bottom">
                        <div class="wrong_count">答错 {{ques.wrong_count}} 人</div>
                        <div class="wrong_rate">试题错误率 {{ques.wrong_rate}}%</div>
                    </div>
                </div>
            </div>
            <more-loading v-if="haveMore"></more-loading>
        </template>
        <noResouse :text="text"
                   v-else></noResouse>
    </div>
</template>

<script>
import moreLoading from 'COMPONENTS/moreLoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';
export default {
    components: { moreLoading, noResouse },
    props: ["question_list", "sid", "haveMore", "text", "status"],
    mounted () {
        if ((this.sid + "").indexOf("2") > -1) {
            this.$nextTick(function () {
                MathJax.Hub.Typeset(document.body)
            })
        }
    },
    methods: {
        getType (type) {
            let arr = [];
            if (this.sid == 21) {
                arr = ["选择题", "填空题", "解答题", "连线题"];
            } else if (this.sid == 22) {
                arr = ["选择题", "", "主观题"];
            } else if (this.sid == 51) {
                arr = ["单选", "填空", "判断", "连线", "排序", "断句", "解答", "阅读理解"]
            } else if (this.sid == 91) {
                arr = ["选择", "连线", "排序", "判断正误", "英汉互译", "情景交际", "完形填空", "阅读理解", "填空", "连词成句", "连句成段"]
            } else if (this.sid == 92) {
                arr = ["听力选择题", "单选", "完型填空", "阅读理解"]
            }
            return arr[type - 1]
        },
        to (q, index) {
            let obj = {
                question: q,
                index: index
            }
            this.$emit('childClick', obj);
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.question_wrapper {
    min-height: 70vh;
    .question_item {
        background-color: #fff;
        border-radius: 10px / $ppr;
        padding: 30px / $ppr;
        margin-bottom: 32px / $ppr;
        &:last-child {
            margin-bottom: 0;
        }
        .question_number {
            // line-height: 82px/$ppr;
            line-height: 48px / $ppr;
            font-size: 28px / $ppr;
            font-weight: bold;
            // padding:0 0 10px/$ppr;
        }
        .question_type {
            // line-height: 82px/$ppr;
            font-size: 28px / $ppr;
            line-height: 48px / $ppr;
            font-weight: bold;
            margin-left: -15px / $ppr;
            // padding:20px/$ppr 0 0;
            // padding-bottom:14px/$ppr;
        }
        .question_content {
            line-height: 48px / $ppr;
            font-size: 28px / $ppr;
            .ques_title {
                padding-bottom: 12px / $ppr;
            }
            .ques_img {
                margin: 10px / $ppr auto;
                display: block;
            }
        }
        .item_bottom {
            color: #999;
            line-height: 78px / $ppr;
            height: 78px / $ppr;
            .wrong_count {
                float: left;
            }
            .wrong_rate {
                float: right;
            }
        }
    }
    .sub_title {
        word-break: break-word;
        word-wrap: break-word;
        padding: 10px / $ppr 0 40px / $ppr;
    }
}
</style>